import { MATCH_FILTER_NAMES } from './constants';

interface FilterNameMap {
  [key: string]: string;
}

export const filterNameMap: FilterNameMap = {
  filter_programmableTags: MATCH_FILTER_NAMES.PROGRAMMABLE_TAGS_MATCH,
  filter_tags: MATCH_FILTER_NAMES.TAGS_MATCH,
};

export const isMatchAll = (filterKey: string) => {
  const filterName = filterNameMap[filterKey] ?? null;
  const params = new URLSearchParams(window?.location.search);
  return !!params.getAll(filterName)?.length;
};
